// src/lib/sessionApi.js — name support + setMediaSource
import { io } from "socket.io-client";

function resolveSocketBase() {
  // 1. Dev: als de frontend op localhost draait → altijd lokale backend
  if (
    typeof window !== "undefined" &&
    window.location.hostname === "localhost"
  ) {
    return "http://localhost:5000";
  }

  // 2. Prod: bondapp.tv → productie signaling backend
  if (
    typeof window !== "undefined" &&
    window.location.hostname === "bondapp.tv"
  ) {
    return "https://signal.bondapp.tv";
  }

  // 3. Optioneel: override via env (bijv. staging)
  const ENV_SIGNALING = process.env.REACT_APP_SIGNALING_URL;
  if (ENV_SIGNALING) return ENV_SIGNALING;

  const ENV_API_BASE = process.env.REACT_APP_API_BASE;
  if (ENV_API_BASE) return ENV_API_BASE;

  // 4. Fallback (dev)
  return "http://localhost:5000";
}


export const API_URL = resolveSocketBase();

console.log("BOND SOCKET API_URL =", API_URL);

export const socket = io(API_URL, {
  autoConnect: true,
  transports: ["websocket"],
  withCredentials: true,
});

const listeners = new Map();

export function on(event, handler) {
  const wrapped = (...args) => handler(...args);
  socket.on(event, wrapped);
  const offs = listeners.get(event) || [];
  offs.push(wrapped);
  listeners.set(event, offs);
  return () => socket.off(event, wrapped);
}

export function createSession(payload = {}) {
  return new Promise((resolve) => {
    socket.emit("session:create", payload, (res) => resolve(res));
  });
}

export function joinSession(code) {
  return new Promise((resolve) => {
    socket.emit("session:join", { code }, (res) => resolve(res));
  });
}

export function leaveSession() {
  return new Promise((resolve) => {
    socket.emit("session:leave", {}, () => resolve(true));
  });
}

export function mediaCommand(payload) {
  socket.emit("media:command", payload);
}

export function setMediaSource(payload) {
  // payload: { mode: "mp4" | "hls", url: string }
  socket.emit("media:source", payload);
}
